
import axios from 'axios';
import * as Constants from '../Common/constants';
export default {
    leaderboard: {
        read: (tid) => {
            if (!tid){
                tid = Constants.LEADERBOARD_ID;
            }
            var url = Constants.SERVER + '/leaderboard/' + tid;

            return axios.get(url).then(
                res => res.data
                ).catch(error => { throw new Error(error); });
        },

        

    }
}



// WEBPACK FOOTER //
// ./src/Api/leaderboard.js